import React from 'react';
import { Shield, Lock } from 'lucide-react';
import { CTAButton } from './CTAButton';
export function Guarantee() {
  return <section className="py-20 px-4 bg-white" data-id="element-99">
      <div className="max-w-3xl mx-auto text-center" data-id="element-100">
        <div className="bg-gradient-to-b from-amber-50 to-white border border-orange-200 rounded-3xl p-8 md:p-12 shadow-2xl relative overflow-hidden" data-id="element-101">
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-32 h-32 bg-teal-200/40 blur-3xl rounded-full" data-id="element-102"></div>

          <Shield className="w-16 h-16 text-teal-600 mx-auto mb-6" data-id="element-103" />

          <h2 className="text-3xl md:text-4xl font-extrabold text-slate-900 mb-8" data-id="element-104">
            🛡️ GARANTÍA TOTAL 7 DÍAS
          </h2>

          <p className="text-xl text-slate-700 mb-8 font-medium" data-id="element-105">
            Usá el sistema durante una semana completa.
          </p>

          <div className="text-left bg-white p-6 rounded-xl border border-orange-200 mb-8 space-y-4 shadow-sm" data-id="element-106">
            <p className="text-slate-700 font-medium" data-id="element-107">Si no sentís:</p>
            <ul className="space-y-3 text-slate-700" data-id="element-108">
              <li className="flex items-start gap-3" data-id="element-109">
                <span className="text-teal-600 mt-1" data-id="element-110">•</span>
                Más claridad sobre cómo ayudar a tu ser querido en el día a día
              </li>
              <li className="flex items-start gap-3" data-id="element-111">
                <span className="text-teal-600 mt-1" data-id="element-112">•</span>
                Una diferencia real en la energía y el estado de ánimo del
                adulto mayor
              </li>
              <li className="flex items-start gap-3" data-id="element-113">
                <span className="text-teal-600 mt-1" data-id="element-114">•</span>
                Un sistema concreto para aprovechar cada momento familiar de
                forma significativa
              </li>
            </ul>
          </div>

          <p className="text-xl font-bold text-slate-900 mb-4" data-id="element-115">
            Te devolvemos el 100% del dinero.
          </p>
          <p className="text-slate-600 mb-12" data-id="element-116">
            Sin preguntas. Sin formularios. Sin vueltas.
          </p>

          <div className="space-y-6" data-id="element-117">
            <CTAButton text="SÍ, QUIERO MENTE ACTIVA →" isMain={true} className="w-full md:w-auto" data-id="element-118" />

            <p className="text-2xl font-bold text-slate-900" data-id="element-119">
              $19.990 ARS{' '}
              <span className="text-sm text-slate-600 font-normal block md:inline md:ml-2" data-id="element-120">
                — Pago único — Acceso inmediato
              </span>
            </p>

            <div className="flex flex-col items-center gap-4 pt-6 border-t border-orange-200" data-id="element-121">
              <div className="flex items-center gap-2 text-sm text-slate-600" data-id="element-122">
                <Lock className="w-4 h-4 text-teal-600" data-id="element-123" />
                <span data-id="element-124">
                  Desde aquí te redirigiremos a Mercado Pago para que puedas
                  hacer tu compra de manera 100% segura
                </span>
              </div>
              <img src="https://logospng.org/download/mercado-pago/logo-mercado-pago-icono-1024.png" alt="Mercado Pago" className="h-8 opacity-90 hover:opacity-100 transition-all" data-id="element-125" />
            </div>
          </div>
        </div>
      </div>
    </section>;
}